export const fields = `
    eyebrow,
    header,
    subtitle,
    showWhatToExpect,
    expectationItems[] {
      _key,
      icon {
        asset-> {
          _id,
          url,
          metadata {
            dimensions {
              width,
              height
            }
          }
        }
      },
      title,
      description
    },
    successMessage {
      title,
      subtitle,
    }
  `

export const fragment = (name = 'newsletterSignUp') => `${name}{${fields}}`

const exported = {
  fields,
  fragment,
}

export default exported

